import { UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text } from 'react-native';
import { TranslateProp } from '../../../common-types';
import Theme from '../../../theme';
import useCountDown from '../../../utils/useCountDown';

interface IParentProps {
  workout: UserWorkoutSession;
  t: TranslateProp;
}

const Heading: FunctionComponent<IParentProps> = (
  {
    workout,
    t,
  },
) => {
  const countDown = useCountDown(workout.startTimeOfFirstExercise);

  const getHeadingText = () => {
    if (countDown && countDown.fullMinutes > 1) {
      return t(
        'StartingStudioWorkoutHeaderClassStartsInMinutes',
        { minutes: countDown.fullMinutes.toString(10) },
      );
    }

    if (countDown && countDown.seconds > 1) {
      return t(
        'StartingStudioWorkoutHeaderClassStartsInSeconds',
        { seconds: countDown.seconds.toString(10) },
      );
    }

    return t('StartingStudioWorkoutHeaderWorkoutStarted');
  };

  return (
    <Text style={styles.heading}>{getHeadingText()}</Text>
  );
};

export default translate(['dashboard'], { wait: true })(Heading);

const styles = StyleSheet.create({
  heading: {
    ...Theme.textStyle.heading2,
  },
});
